import { z } from 'zod';

export enum ResponsiblePartyRole {
  CUSTOM = 'CUSTOM',
  CUSTOMER = 'CUSTOMER',
  CUSTOMER_REP = 'CUSTOMER_REP',
  DISPATCHER = 'DISPATCHER',
  LOAD_OWNER = 'LOAD_OWNER',
  OPERATIONS_TEAM = 'OPERATIONS_TEAM',
}

export const NO_RESPONSIBLE_PARTY_ROLE = 'NO_ROLE' as const;

export const SopInputResponsiblePartyRoleSchema = z.union([
  z.literal(NO_RESPONSIBLE_PARTY_ROLE),
  z.nativeEnum(ResponsiblePartyRole),
]);

export type SopInputResponsiblePartyRole = z.infer<
  typeof SopInputResponsiblePartyRoleSchema
>;

// NOTE(martin): Legacy TMS responsible parties have no role, so this default must
// keep NO_RESPONSIBLE_PARTY_ROLE — dropping it here silently excludes them from SOP inputs.
export const DEFAULT_SOP_INPUT_RESPONSIBLE_PARTY_ROLES = [
  NO_RESPONSIBLE_PARTY_ROLE,
] satisfies SopInputResponsiblePartyRole[];
